export function setActiveMarker({commit}, marker) {
    commit('SET_ACTIVE_MARKER', marker);
}

export function setFlyToLocation({commit}, location) {
    commit('SET_FLY_TO', location);
}